const ALLOWED = new Set(['name', 'full_name', 'minutes', 'sender', 'link', 'withdraw_link']);

export function unknownTemplatePlaceholders(...templates) {
  return [...new Set(templates.flatMap((template) => [...template.matchAll(/\{\{\s*([^{}]+?)\s*\}\}/g)].map((match) => match[1].trim())))].filter((name) => !ALLOWED.has(name));
}
